export const themeStorageKey = "cti-theme"

export const getPreferredTheme = () => {
  if (typeof window === "undefined") {
    return "light"
  }

  const storedTheme = window.localStorage.getItem(themeStorageKey)
  if (storedTheme === "light" || storedTheme === "dark") {
    return storedTheme
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light"
}

export const applyTheme = theme => {
  if (typeof document === "undefined") {
    return
  }

  document.documentElement.setAttribute("data-theme", theme)
}

export const persistTheme = theme => {
  if (typeof window === "undefined") {
    return
  }

  window.localStorage.setItem(themeStorageKey, theme)
  applyTheme(theme)
}
